export function SAVE_FILTERS(state, [progress, search, selected_areas, selected_groups, selected_tags]){
    state.progress = progress
    state.search = search
    state.selected_areas = selected_areas
    state.selected_groups = selected_groups
    state.selected_tags = selected_tags
}

export function SAVE_WEBINAR_STATUS(state, [webinar_status]){
    state.webinar_status = webinar_status
}

export function SAVE_WEBINAR_IS_ONLINE(state, [webinar_is_online]){
    state.webinar_is_online = webinar_is_online
}

export function SAVE_LOUNGE_TEMPLATE ( state, [ webcast_lounge_template ] ) {
    state.webcast_lounge_template = webcast_lounge_template
}

export function SAVE_PROGRESS(state, progress){
    state.progress = progress
}

export function SAVE_FILTER_AREA(state, selected_areas){
    state.selected_areas = selected_areas
}

export function SAVE_LOADING(state, loading){
    state.loading = loading
}